// src/helpers/factories/menuModifierItemCardFactory.ts
var menuModifierItemCardFactory = (modifierItems) => Object.values(modifierItems).map((modifierItem) => {
  const modifierGroupsCount = modifierItem.parentModifierGroupIds.length;
  return {
    id: modifierItem.modifierItemId,
    title: modifierItem.name,
    modifierGroupsCount,
    isAssignedToModifierGroup: modifierGroupsCount ? 1 : 2,
    status: modifierItem.active,
    activeFilter: modifierItem.active ? 1 : 2,
    isLinked: !!modifierItem.linkedItemId
  };
});
var selectedModifierItemObjFactory = (modifierItem) => {
  const modifierItemsArr = {
    id: modifierItem.modifierItemId,
    count: 1,
    name: modifierItem.name
  };
  return modifierItemsArr;
};

export { menuModifierItemCardFactory, selectedModifierItemObjFactory };
